import React from 'react'
import styles from "./RoleMgt.module.css"

const TableTitle = () => {
  return (
    <>
    
        <div className = {styles.leaveText}>
          <h4 className ={styles.xlargeTextBold}>Role Management</h4>
        </div>
    
    </>
  )
}

export default TableTitle